import { Box } from '@mui/material'
import { keyframes } from '@mui/system'
import { useEffect, useState, useContext } from 'react'
import loadingGif from 'src/assets/gif/loading.gif'
// context
import { NavigationDataContext } from 'src/store/navigation/Store'

// hooks
import useAPIDataLoader from 'src/hooks/useAPIDataLoader'
import useKeyPress from 'src/hooks/useKeyPress'

// components
import NavBar from 'src/components/NavBar'
import Menu from 'src/components/Menu'
import GameOver from 'src/components/GameOver'
import Event from 'src/components/Event'
import Combat from 'src/components/Combat'
import Stash from 'src/components/Stash'
import Map from 'src/components/Map'
import Veil from 'src/components/Veil'
import useStartGame from 'src/hooks/useStartGame'
import Subtitle from './common/Subtitle'
import OptionButton from './common/OptionButton'

const containerStyle = {
  height: '100vh',
  width: '100vw',
  position: 'absolute',
  display: 'block',
  padding: 0,
  boxShadow: 'none',
  margin: 'auto',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}

const containerStyleDesktop = {
  ...containerStyle,
  maxWidth: '400px'
}

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const Game = () => {
  const [game_started, setGameStarted] = useState(false)
  const [begin, setBegin] = useState(false)
  const { navigation } = useContext(NavigationDataContext)


  // layout
  const [isMobile] = useState(window.innerWidth <= 768)

  // checks if API data is already in context
  const isAPIDataLoaded = useAPIDataLoader()
  const { startGame, startOver } = useStartGame()

  // loads a fresh start
  // alternatively will load the saved state of the player
  useEffect(() => {
    if (!game_started) {
      startGame()
      setGameStarted(true)
    }
  }, [isAPIDataLoaded])

  const enterPressed = useKeyPress('Enter')
  useEffect(() => {
    // if it's cinematic and the only option
    if (isAPIDataLoaded && game_started) {
      setBegin(true)
    }
  }, [enterPressed])

  // development build logs
  useEffect(() => {
    if (process.env.REACT_APP_BENCHMARK === 'true') { console.log('Game mounted') }
    return process.env.REACT_APP_BENCHMARK === 'true' ? () => console.log('Game unmounted') : () => {}
  }, [])

  useEffect(() => {
    if (process.env.REACT_APP_BENCHMARK === 'true') { console.log('Game rendered') }
  })

  return begin ? (
    <Box sx={isMobile ? containerStyle : containerStyleDesktop} className="game">
      {navigation.game_over ? (
        <GameOver isMobile={isMobile} handleClick={() => startOver()} />
      ) : null}

      {!navigation.game_over && navigation.event_open ? (
        <Event />
      ) : null}

      {!navigation.game_over && navigation.stash_open ? (
        <Stash/>
      ) : null }

      {!navigation.game_over && navigation.combat_open ? (
          <Combat />
      ) : null}
      <Veil show={navigation.game_over || navigation.combat_open || navigation.event_open}/>
      
      <Map/>
      { navigation.menu_open ? (
        <Menu/>
      ) : null}
      <NavBar/>
    </Box>
  ) : (
    <Box sx={isMobile ? containerStyle : containerStyleDesktop} className="game">
      <Box sx={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, margin: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
        { isAPIDataLoaded && game_started ? (
          <Box sx={{transform: 'scale(2)', animation: `${fadeIn} 3s ease-out forwards`}}>
          <OptionButton
            text='Enter Samsara'
            color='#c4a26c'
            backgroundColor='#372237'
            borderColor='#372237'
            handleClick={() => { setBegin(true) }}
          />
        </Box>
        ) : (
          <Subtitle>Loading</Subtitle>
        )}
      </Box>
      
      <img src={loadingGif} alt='loading' style={{height: '100%', imageRendering: 'pixelated'}}></img>
    </Box>
  )
}

export default Game
